import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import api from '../api'
import Y from '../../y18n'

const REQUEST_INFORMATION = createAction('gdpr/REQUEST_INFORMATION')
const REQUEST_INFORMATION_SUCCESS = createAction('gdpr/REQUEST_INFORMATION_SUCCESS')
const REQUEST_INFORMATION_ERROR = createAction('gdpr/REQUEST_INFORMATION_ERROR')

const initialState = {
  loading: false,
  information: {},
  error: ''
}

export default handleActions(
  {
    [REQUEST_INFORMATION]: (state, action) => ({
      ...state,
      loading: true,
      information: {}
    }),
    [REQUEST_INFORMATION_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      information: action.payload
    }),
    [REQUEST_INFORMATION_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    })
  },
  initialState
)

export const requestInformation = id => {
  return dispatch => {
    dispatch(REQUEST_INFORMATION())
    return api
      .get('gdpr/requestinformation', id)
      .then(result => {
        dispatch(REQUEST_INFORMATION_SUCCESS(result))
      })
      .catch(error => {
        dispatch(REQUEST_INFORMATION_ERROR(error))
      })
  }
}

export const searchInformation = (email, phoneNumber) => {
  return dispatch => {
    dispatch(REQUEST_INFORMATION())
    return api
      .get('gdpr/searchinformation', '', `email=${email}&phoneNumber=${phoneNumber}`)
      .then(result => {
        dispatch(REQUEST_INFORMATION_SUCCESS(result))
      })
      .catch(error => {
        dispatch(REQUEST_INFORMATION_ERROR(error))
        dispatch(globalMessageActions.setGlobalError(Y`An error occured. Error: ${error}`))
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/gdpr/index.js